import React from 'react'
import './ActionButtons.css'

const ActionButtons = ({ buttons }) => {
  return (
    <div className="action-buttons-container">
      {buttons.map((button, index) => (
        <button
          key={index}
          className="action-button"
          onClick={button.onClick}
        >
          {button.label}
        </button>
      ))}
    </div>
  )
}

export default ActionButtons










